import mutations from './humanResource.mutations'
import actions from './humanResource.actions'
import getters from './humanResource.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
